import { getObjectUtil } from 'packages/src'
import { getIdReduxUtil } from '../../../redux/utils/get-id'
import getCurrentWorkoutSectionStartWorkoutSelect from '../get-current-workout-section'
import { WORKOUT_EXERCISES_PATH } from '../../../workout-exercise/redux/constants'
import getWorkoutExercisesWorkoutSectionUtil from '../../../workout-section/model/utils/get-workout-exercises'
import { createSelector } from 'reselect'

function getCurrentWorkoutSectionWorkoutExercisesStartWorkoutSelector (workoutSectionParam) {
  return createSelector(
    state => getObjectUtil(state, WORKOUT_EXERCISES_PATH.DATA),
    getCurrentWorkoutSectionStartWorkoutSelect,
    (workoutExercisesDomainMap, curWorkoutSection) => {
      const workoutSection = workoutSectionParam || curWorkoutSection
      if (!workoutSection) {
        return
      }
      const workoutExercisePointers = getWorkoutExercisesWorkoutSectionUtil(
        workoutSection)
      return workoutExercisePointers.map(pointer => (
        workoutExercisesDomainMap[getIdReduxUtil(pointer)]
      ))
    }
  )
}

export default getCurrentWorkoutSectionWorkoutExercisesStartWorkoutSelector
